// extracted by mini-css-extract-plugin
export default {"container":"DocumentCheckableControl_container__c+VOZ","checkbox":"DocumentCheckableControl_checkbox__x5cMn"};